export default __webpack_public_path__ + "static/media/faustin_walk_sheeps.204bb789.jpg";